import * as jsxRuntime from "D:\\SMPL\\ecom_clothing\\ecom_adc\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment